import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Icon, BasicTooltip, toast } from '@livable/saas-react-components';
import { useTranslation } from 'react-i18next';
import { Table, TableHead, TableBody, TableRow, TableCell, IconButton, Collapse, Button, Typography } from '@mui/material';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { BatchDueReminderModal } from 'src/components/unit/BatchDueReminderModal';
export default function Row(_ref) {
  let data = _ref.data;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  const propertyAddress = data.propertyAddress,
    propertyId = data.propertyId,
    residents = data.residents;
  const handleDownloadReport = async (e, propId) => {
    e.stopPropagation();
    const getFileName = headers => {
      var _headers$fileName;
      return (_headers$fileName = headers['file-name']) !== null && _headers$fileName !== void 0 ? _headers$fileName : null;
    };
    const _await$store$report$d = await store.report.downloadPropertyReportAsync.run({
        propertyId: propId
      }),
      downloadedFile = _await$store$report$d.data,
      headers = _await$store$report$d.headers;
    const encodedUri = window.URL.createObjectURL(new Blob([downloadedFile], {
      type: 'application/octet-stream'
    }));
    let link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', getFileName(headers));
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };
  const sendReminderToAllTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    className: classes.sendReminderToAllTrigger,
    'custom-attribute': '789-reporting-page-reimbursement-tab'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('reimbursement_dashboard.send_reminder_to_all')));
  const handleSendBalanceRemainder = async currentAccountId => {
    setIsLoading(true);
    const resp = await store.payment.sendBalanceRemainderAsync.run({
      accountId: currentAccountId
    });
    if (resp && resp.isSuccessful) {
      toast('success', {
        body: ['Successfully sent']
      });
    }
    setIsLoading(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableRow, {
    key: propertyId
  }, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    onClick: () => setIsOpen(!isOpen),
    className: "".concat(classes.arrow, " ").concat(isOpen ? classes.arrowIsOpen : '')
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-line-down"
  }))), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.addressCell
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    title: propertyAddress,
    placement: "top"
  }, propertyAddress)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '790-reporting-page-reimbursement-tab'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText",
    onClick: e => handleDownloadReport(e, propertyId),
    'custom-attribute': '791-reporting-page-reimbursement-tab'
  }, t('reimbursement_dashboard.download_report'))), /*#__PURE__*/React.createElement(BatchDueReminderModal, {
    trigger: sendReminderToAllTrigger,
    exportedData: residents
  }))), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    colSpan: 8,
    className: classes.collapseTable
  }, /*#__PURE__*/React.createElement(Collapse, {
    in: isOpen,
    className: isOpen ? classes.collapseIsOpen : ''
  }, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, t('reimbursement_dashboard.unit')), /*#__PURE__*/React.createElement(TableCell, null, t('reimbursement_dashboard.resident')), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.periodCell,
    align: "right"
  }, t('reimbursement_dashboard.current')), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.periodCell,
    align: "right"
  }, t('reimbursement_dashboard.one_thirty_days')), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.periodCell,
    align: "right"
  }, t('reimbursement_dashboard.thirty_sixty_days')), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.periodCell,
    align: "right"
  }, t('reimbursement_dashboard.sixty_ninety_days')), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.periodCell,
    align: "right"
  }, t('reimbursement_dashboard.ninety_one_and_over')), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.totalCell,
    align: "right"
  }, t('reimbursement_dashboard.total_owed')), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.actionCell,
    align: "right"
  }, t('reimbursement_dashboard.action')))), /*#__PURE__*/React.createElement(TableBody, null, (residents === null || residents === void 0 ? void 0 : residents.length) && residents.sort((a, b) => {
    var _ref2;
    return (_ref2 = '' + (a === null || a === void 0 ? void 0 : a.unitName)) === null || _ref2 === void 0 ? void 0 : _ref2.localeCompare(b === null || b === void 0 ? void 0 : b.unitName, undefined, {
      numeric: true
    });
  }).map(resident => /*#__PURE__*/React.createElement(TableRow, {
    key: (resident === null || resident === void 0 ? void 0 : resident.propertyId) + (resident === null || resident === void 0 ? void 0 : resident.unitName)
  }, /*#__PURE__*/React.createElement(TableCell, {
    className: classes.unitCell
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    title: resident === null || resident === void 0 ? void 0 : resident.unitName,
    placement: "top"
  }, resident.unitName)), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.tooltipCellSm
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    title: resident.residentFullName,
    placement: "top"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body3"
  }, resident.residentFullName), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "small",
    type: "mail"
  }), resident !== null && resident !== void 0 && resident.emailAddress ? ' ' + resident.emailAddress : ' N/A'), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "small",
    type: "phone"
  }), resident !== null && resident !== void 0 && resident.phone ? ' ' + resident.phone : ' N/A'))), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, resident !== null && resident !== void 0 && resident.currentPeriod ? "$".concat(Number(resident === null || resident === void 0 ? void 0 : resident.currentPeriod).toFixed(2)) : 'N/A'), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, resident !== null && resident !== void 0 && resident.dayMonthPeriod ? "$".concat(Number(resident === null || resident === void 0 ? void 0 : resident.dayMonthPeriod).toFixed(2)) : 'N/A'), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, resident !== null && resident !== void 0 && resident.oneMonthTwoMonthPeriod ? "$".concat(Number(resident === null || resident === void 0 ? void 0 : resident.oneMonthTwoMonthPeriod).toFixed(2)) : 'N/A'), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, resident !== null && resident !== void 0 && resident.twoMonthThreeMonthPeriod ? "$".concat(Number(resident === null || resident === void 0 ? void 0 : resident.twoMonthThreeMonthPeriod).toFixed(2)) : 'N/A'), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, resident !== null && resident !== void 0 && resident.moreThreeMonthPeriod ? "$".concat(Number(resident === null || resident === void 0 ? void 0 : resident.moreThreeMonthPeriod).toFixed(2)) : 'N/A'), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, resident !== null && resident !== void 0 && resident.total ? "$".concat(Number(resident === null || resident === void 0 ? void 0 : resident.total).toFixed(2)) : 'N/A'), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    title: resident.emailAddress !== null ? t('reimbursement_dashboard.send_reminder_to', {
      emailAddress: resident.emailAddress
    }) : t('reimbursement_dashboard.send_reminder_no_resident_email'),
    placement: "top"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    disabled: isLoading || resident.emailAddress === null,
    onClick: () => {
      handleSendBalanceRemainder(resident.accountId);
    },
    'custom-attribute': '792-reporting-page-reimbursement-tab'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('reimbursement_dashboard.send_reminder'))))))))))))));
}